import styled from '@emotion/styled'

export const DIV = styled.div((props)=>({
    ...props.className,
    img: {
        width: 20
    }
}))